import './lib/resizeObserverPatch';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import App from './App.jsx';
import './index.css';
// queryClient is imported where needed (e.g. in App via QueryClientProvider)

const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const posthogHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

let posthogInstance = null;

if (posthogKey && posthogHost) {
    posthog.init(posthogKey, {
        api_host: posthogHost,
        ui_host: posthogHost,
        person_profiles: 'identified_only',
        capture_pageview: true,
        autocapture: true,

        // Improved error handling - silently fail if blocked
        loaded: () => {
            if (import.meta.env.DEV) console.log('PostHog loaded successfully');
        },

        // Suppress error logging for blocked requests
        on_request_error: error => {
            // Only log in development and only if it's not a blocking error
            if (import.meta.env.DEV && !error.message?.includes('ERR_BLOCKED_BY_CLIENT')) {
                console.warn('PostHog request error:', error);
            }
            // Silently fail for blocked requests in production
        },

        // Additional settings to handle ad blockers gracefully
        persistence: 'localStorage+cookie',
        bootstrap: {
            distinctID: undefined,
        },

        // Retry configuration - reduce retries to minimize console spam
        retry: {
            max_retries: 1, // Reduce from default 3
            retry_delay: 1000,
        },
    });

    posthogInstance = posthog;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
if (import.meta.env.DEV) {
    // Render immediately in development to avoid double-mounting side-effects
    root.render(<App posthogInstance={posthogInstance} />);
} else {
    root.render(
        <StrictMode>
            <App posthogInstance={posthogInstance} />
        </StrictMode>
    );
}
